import { AccountTree, Print, Schedule } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';

interface ViewBracketsProps {
  viewMode: 'schedule' | 'brackets';
  setViewMode: (mode: 'schedule' | 'brackets') => void;
  handlePrint: () => void;
}

const ViewBrackets: React.FC<ViewBracketsProps> = ({ viewMode, setViewMode, handlePrint }) => {
  return (
     <Box>
        <div>
          ViewBrackets
        </div>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h6">
            Step 4: View Tournament
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant={viewMode === 'schedule' ? 'contained' : 'outlined'}
              onClick={() => setViewMode('schedule')}
              startIcon={<Schedule />}
            >
              Mat Schedule
            </Button>
            <Button
              variant={viewMode === 'brackets' ? 'contained' : 'outlined'}
              onClick={() => setViewMode('brackets')}
              startIcon={<AccountTree />}
            >
              Brackets
            </Button>
            <Button
              variant="outlined"
              onClick={handlePrint}
              startIcon={<Print />}
            >
              Print
            </Button>
          </Box>
        </Box>
     </Box>
  )
}

export default ViewBrackets;